import React, { useState, useEffect } from 'react';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import SearchBoxInput from '../product-search/shared/SearchBoxInput';
import { useSearchTracking } from '../product-search/shared/useSearchTracking';

function CustomSearchBox(props) {
  const { query, refine } = useSearchBox(props);
  const { status } = useInstantSearch();
  const [inputValue, setInputValue] = useState(props.keyword ?? query);

  const isSearchStalled = 'stalled' === status;

  const debouncedTrackEvent = useSearchTracking('search_connected_plus_product');

  useEffect(() => {
    if (props.keyword) {
      setQuery(props.keyword, true);
    }
    return () => {
      props.setSuggestion('');
    };
  }, []);

  function setQuery(newQuery, isSuggestion = false) {
    if (!isSuggestion) {
      debouncedTrackEvent(newQuery);
    }
    setInputValue(newQuery);
    refine(newQuery);
  }

  return (
    <SearchBoxInput
      value={inputValue}
      onChange={(newQuery) => setQuery(newQuery)}
      isSearchStalled={isSearchStalled}
    />
  );
}

export default CustomSearchBox;
